export const MuiAppBar = (mode) => {
  return {
    MuiAppBar: {
      styleOverrides: {
        root: ({ theme }) => ({
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.primary,
          borderBottom: `1px solid ${theme.palette.divider}`,
          boxShadow: "none",
          height: "53px",
        }),
      },
    },
  };
};
